"use client";

import { createContext, type ReactNode, useContext } from "react";

type ToolSuccessEffectInput = {
  toolName: string;
  toolCallId: string;
};

export type ToolSuccessEffect = (input: ToolSuccessEffectInput) => void;

const ToolSuccessEffectsContext = createContext<ToolSuccessEffect | null>(null);

const noToolSuccessEffect: ToolSuccessEffect = () => undefined;

/** AI tool成功後のroute固有処理を、共通UIへtool名を持ち込まずに提供する。 */
export function ToolSuccessEffectsProvider({
  effect,
  children,
}: {
  effect: ToolSuccessEffect;
  children: ReactNode;
}): ReactNode {
  return (
    <ToolSuccessEffectsContext.Provider value={effect}>
      {children}
    </ToolSuccessEffectsContext.Provider>
  );
}

/** route固有の成功処理を返す。Providerがない画面では安定したno-opを返す。 */
export function useToolSuccessEffect(): ToolSuccessEffect {
  return useContext(ToolSuccessEffectsContext) ?? noToolSuccessEffect;
}
